<template>
  <div class="comp-intro">
    <div class="new-title">{{NewsTitle}}</div>
    <div class="new-content" v-html="NewsContent"></div>

    <el-empty description="暂无数据" v-if="!NewsContent"></el-empty>
  </div>
</template>

<script>
import { CompService } from '/@/service'

export default {
  data() {
    return {
      NewsTitle: '',
      NewsContent: '',
    }
  },
  mounted() {
    this.getCompIntro();
  },
  methods: {
    async getCompIntro() {
      const res = await CompService.getCompIntro(this.$route.params.id);
      if (res) {
        this.NewsTitle = res.NewsTitle || '';
        this.NewsContent = res.NewsContent || '';
      }
    }
  }
}
</script>

<style lang="less" scoped>
.new-title{
  font-weight: 400;
  color: #333333;
  line-height: 28px;
}
</style>
